import axios from "axios";
import store from "../store.js";

class UploadFilesService {
  upload(id, final, object_type, fileType, bool_public, file, onUploadProgress) {
    let dataFile = new FormData();
    dataFile.append('name', file.name);
    dataFile.append('type', fileType);
    dataFile.append('public', bool_public);
    dataFile.append("file", file);

    let path;
    if(final){
      path = store.state.endpoint + "/" + object_type + "/files/" + id;
    }else{
      path = store.state.endpoint + "/modOp/" + object_type + "/files/" + id;
    }
    return axios.post(path, dataFile, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress
    });
  }

  getFiles(id, final, object_type) {
    let path;
    if(final){
      path = store.state.endpoint + "/" + object_type + "/files/" + id;
    }else{
      path = store.state.endpoint + "/modOp/" + object_type + "/files/" + id;
    }
    return axios.get(path)
  }

  deleteFile(fileId, object_type) {
    const path = store.state.endpoint + "/" + object_type + "/files/get/" + fileId;
    return axios.delete(path)
  }

  updateFilePublic(id, final, object_type, fileId, isPublic) {
    let path;
    if (final) {
      path = store.state.endpoint + "/" + object_type + "/files/get/" + fileId;
    } else {
      path =
        store.state.endpoint +
        "/modOp/" +
        object_type +
        "/files/" +
        id +
        "/" +
        fileId;
    }
    return axios.patch(path, { public: isPublic });
  }
}

export default new UploadFilesService();
